module.exports = __webpack_public_path__ + "img/cart-icon.05b24a9.svg";